export type Frequency = 'NONE' | 'DAILY' | 'QUARTERLY';
export const FrequencyTypes = {
  NONE: 'NONE' as Frequency,
  DAILY: 'DAILY' as Frequency,
  QUARTERLY: 'QUARTERLY' as Frequency
};

export interface BackgroundPref {
  backgroundPhoto?: string;
  backgroundRotation: Frequency;
}

export class PersonPref implements BackgroundPref {
  clazz: string;
  backgroundPhoto?: string;
  backgroundRotation: Frequency;
}



// WEBPACK FOOTER //
// ./src/gs-core/common/models/person-pref.ts